<template>
    <!-- Electric Chargers Section Start -->
    <section id="open-positions" class="d-flex justify-content-center py-4 mt-5">
        <div class="container">
            <!-- Main Title with Subtitle -->
            <h1 class="section-title color-main my-4 pb-3">Euro Petrol Klub</h1>
            <!-- Main Title with Subtitle End -->
            <a href="/euro-petrol-klub">
              <img
                  src="/img/landing_page/new_download_app_banner@2x.webp"
                  class="img-fluid py-2 w-100 d-md-block d-none"
                  alt="Preuzmi Euro Petrol aplikaciju. Instaliraj, registruj se i ostvari mnogobroine pogodnosti!"
              >
              <img
                  src="/img/landing_page/new_download_app_mobile_banner.webp"
                  srcset="/img/landing_page/new_download_app_mobile_banner@2x.webp 2x"
                  class="img-fluid py-2 w-100 d-md-none d-block"
                  alt="Preuzmi Euro Petrol aplikaciju. Instaliraj, registruj se i ostvari mnogobroine pogodnosti!"
              >
            </a>
            <div class="row justify-content-between py-5">
                <div class="col-12 d-flex flex-column">
                    <span class="fw-bold mb-2 fs-5 color-main">Euro Petrol Klub lojalnosti</span>
                    <p class="section-subtitle">Preuzmi <b>Euro Petrol mobilnu aplikaciju namenjenu fizičkim licima</b> i učlani se za nekoliko minuta u naš klub lojalnosti!</p>
                    <p class="fw-bold color-main mt-4 mb-0 fs-5">Šta dobijaš:</p>
                    <ul class="section-subtitle">
                        <li>Uštedu <b>do 5 RSD po litru</b> goriva pri svakom točenju</li>
                        <li>Popuste na <b>auto kozmetiku, pranje i usisavanje</b></li>
                        <li>Brz uvid u <b>potrošnju goriva i ukupne uštede</b></li>
                        <li>Mapa najbližih <b>Euro Petrol</b> stanica i pregled <b>aktuelnih akcija</b></li>
                    </ul>
                    <b>Članstvo je besplatno i bezuslovno.</b>
                </div>

                <div class="col-lg-12 my-2">
                    <button aria-label="Detaljnije informacije" class="btn btn-secondary lh-lg rounded-0 d-flex align-items-center gap-1" type="submit"  @click="isOpen = !isOpen;"> Detaljnije informacije o popustima <i class="ri-download-line color-main"></i></button>
                <transition name="modal-custom">
                <div v-if="isOpen">
                    <div class="overlay-modal" @click.self="isOpen = false;">
                        <div class="modal-custom">
                            <img src="../../assets/media/epk-popust-oct-2026.webp" class="img-fluid" alt="Informacije o Euro Petrol Klub popustima">
                        </div>
                    </div>
                </div>
                </transition>

                </div>
            </div>
        </div>
    </section>
    <!-- Electric Chargers Section End -->
</template>

<script>
export default {
  data: function() {
    return {
      isOpen: false
    };
  }
};
</script>

<style scoped>
.job-item{
    padding: 2.6em;
    border: 1px solid #e0e0e0;
}

.mw-47rem{
    max-width: 47em;
}

.modal-custom {
  display: flex;
  align-items: center;
  width: 50%;
  height: 80%;
  margin: 0px auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px 3px;
  transition: all 0.2s ease-in;
  font-family: Helvetica, Arial, sans-serif;
  overflow-y: auto;
  touch-action: pan-y !important;
}
.fadeIn-enter {
  opacity: 0;
}

.fadeIn-leave-active {
  opacity: 0;
  transition: all 0.2s step-end;
}

.fadeIn-enter .modal,
.fadeIn-leave-active.modal {
  transform: scale(1.1);
}

.overlay-modal {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #00000094;
  z-index: 9999;
  transition: opacity 0.2s ease;
}

@media (max-width: 900px) {
  .modal-custom{
    width: 100%;
    height: 70%;
  }
}
</style>
